import { Box } from '@mui/material';

import Accordion from '../../accordion/accordion';
import Typography from '../../typography/typography';

export interface ISubtotalSummary {
	subtotalExTax: number | string;
	subtotalExDiscount: number | string;
	currencySymbol: string;
}
interface ISubtotalSummaryProps {
	data: ISubtotalSummary;
}

const SubtotalSummary: React.FC<ISubtotalSummaryProps> = ({ data }) => {
	return (
		<Accordion
			title={
				<Typography type='s3' weight='medium' color='theme.secondary.1000'>
					Subtotal
				</Typography>
			}
			accordionProps={{
				defaultExpanded: true,
				sx: {
					borderBottomWidth: 1,
					'& .MuiAccordionSummary-root': { borderBottomWidth: 1 }
				}
			}}>
			<Box className='calculationSummary--SummaryContainer'>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Subtotal Excluding Taxes
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.subtotalExTax}
					</Typography>
				</Box>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Subtotal Excluding discount
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.subtotalExDiscount}
					</Typography>
				</Box>
			</Box>
		</Accordion>
	);
};

export default SubtotalSummary;
